<template>
            <a
                href="javascript:void(0)"
                @click="handleClick"
                class="card text-center text-secondary"
                style="width: 10rem; height: 10rem;">
                <div class="card-block" style="padding-top:5px">
                    <i
                        v-if="icon"
                        v-bind:class="icon"
                        style="font-size: 92px;">
                    </i>
                </div>
                <h4><b>{{title}}</b></h4>
            </a>
</template>

<script>

export default {
  name: 'selectableCard',

  props: {
    icon: { required: false },
    title: { required: true }
  },

  data () {
    return {

    }
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
</style>
